import v2 from '../v2Client';

const PORTAL_UPDATES_PATH = '/portal-updates';

const state = {
  items: [],
};

const getters = {
  unread: (state) => state.items.filter((item) => !item.read),
  unreadCount: (state, getters) => getters.unread.length,
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
  SET_READ(state, { id, read }) {
    const item = state.items.find((candidate) => candidate.id === id);
    if (item) item.read = read;
  },
};

const actions = {
  async fetch({ commit }) {
    try {
      const { data } = await v2.get(PORTAL_UPDATES_PATH);
      commit('SET_ITEMS', data.data);
    } catch (error) {
      commit('SET_ITEMS', []);
    }
  },
  async markRead({ commit }, id) {
    commit('SET_READ', { id, read: true });
    try {
      await v2.post(`${PORTAL_UPDATES_PATH}/${id}/read`);
    } catch (error) {
      commit('SET_READ', { id, read: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
